<template>
    <div class="grid modal-comment__container">
      <div class="grid__col--2 modal-comment__icon-container h-center-align">
        <div class="modal-comment--blank modal-comment__icon modal-comment__icon--blank"></div>
      </div>
      <div class="grid__col--10 h-no-padding modal-comment__text-container">
        <div class="modal-comment__author modal-comment__author--blank modal-comment--blank"></div>
        <div class="modal-comment__datetime modal-comment__datetime--blank modal-comment--blank"></div>
        <div class="modal-comment__content modal-comment__content--blank">
          <div class="modal-comment__text-line modal-comment--blank"></div>
          <div class="modal-comment__text-line modal-comment--blank"></div>
          <div class="modal-comment__text-line modal-comment--blank"></div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'CommentSkeleton'
  }
</script>
